// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","ServicePhone":"Footer_ServicePhone__5-6fh","PhoneIconLink":"Footer_PhoneIconLink__ho92I","AccoladeLogo":"Footer_AccoladeLogo__9-B-Q"};